module.exports = __webpack_public_path__ + "img/victron_8A_24V.23da6007.png";